import React from 'react';
import { styled } from '@compiled/react';
import Lozenge from '@atlaskit/lozenge';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';

type Props = {
	letter: string;
};

const LetterIcon = ({ letter }: Props) => (
	<Lozenge>
		<Letter>{letter}</Letter>
	</Lozenge>
);

export const DateFieldIcon = () => <LetterIcon letter="D" />;
export const SprintDateIcon = () => <LetterIcon letter="S" />;
export const ReleaseDateIcon = () => <LetterIcon letter="R" />;

export default LetterIcon;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Letter = styled.span({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	fontSize: gridSize * 1.75,
});
